import PgxCardTemplate from '../../../../../components/CockpitCards/PgxCardTemplate';
import PharmaDrugsSubText2 from './PharmaDrugsSubText2';
import { API_URL } from '../../../../../constants';


export default function DrugAccCard() {


return(
<>

<PgxCardTemplate

  panel_url = {`${API_URL}/api/pgxguidelines`}
  
  panel_name = "Medication Guide" 
  panel_subtext = {<PharmaDrugsSubText2 />}
  
/>

</>
)
}

